var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.enable)?_c('div',[(_vm.isCalculatorApplicant && !_vm.isUserSecondaryApplicant)?_c('CalculatorHome'):(!_vm.isUserSecondaryApplicant && !_vm.isCalculatorApplicant)?_c('Home'):_c('HomeSecondary')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }